/**
 * Hero Section — Parallax
 *
 * Moves [data-parallax] elements up to 50px on scroll,
 * staying within their container mask (overflow: hidden on parent).
 */
( function () {
	'use strict';

	const PARALLAX_DISTANCE = 50;

	function initParallax() {
		const targets = document.querySelectorAll( '.hero-section [data-parallax]' );
		if ( ! targets.length ) return;

		let ticking = false;

		function update() {
			targets.forEach( function ( el ) {
				const section = el.closest( '.hero-section' );
				if ( ! section ) return;

				const isSplitHero = section.classList.contains( 'hero-section--image-left' ) || section.classList.contains( 'hero-section--image-right' );
				if ( isSplitHero && window.innerWidth <= 1024 ) {
					el.style.transform = 'translateY(0px)';
					return;
				}

				const rect     = section.getBoundingClientRect();
				const winH     = window.innerHeight;
				const progress = 1 - ( rect.bottom / ( winH + rect.height ) );
				const offset   = Math.round( progress * PARALLAX_DISTANCE * 2 - PARALLAX_DISTANCE );
				const clamped  = Math.max( -PARALLAX_DISTANCE, Math.min( PARALLAX_DISTANCE, offset ) );

				el.style.transform = `translateY(${ clamped }px)`;
			} );

			ticking = false;
		}

		function onScroll() {
			if ( ! ticking ) {
				requestAnimationFrame( update );
				ticking = true;
			}
		}

		// capture: true catches scroll from any scrollable ancestor, not just window
		window.addEventListener( 'scroll', onScroll, { passive: true, capture: true } );
		document.addEventListener( 'scroll', onScroll, { passive: true, capture: true } );

		update();
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initParallax );
	} else {
		initParallax();
	}
} )();